package com.essntl.features.address.ui

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.State
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.address.domain.model.AddressModel
import com.essntl.features.address.domain.repository.AddressRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlin.collections.map
import kotlin.collections.orEmpty

class AddressViewModel(
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
    private val addressRepository: AddressRepository,
    private val state: MutableStateFlow<AddressState>,
) : ViewModel {

    fun onEvent(event: AddressEvent) {
        when (event) {
            is AddressEvent.GetAddress -> getAddress(event)
            is AddressEvent.AddAddress -> addAddress()
            is AddressEvent.EditAddress -> editAddress()
            is AddressEvent.UpdateAddressFields -> updateAddressFields(event)
            is AddressEvent.Clear -> clear()
            is AddressEvent.ClearSuccessState -> clearSuccessState()
        }
    }

    fun isAddressChanged(): Boolean {
        val oldAddress = state.value.getAddress.data ?: AddressModel.empty
        val newAddress = oldAddress.getChangedFields(state.value.address.value)
        return !newAddress.isEmpty
    }

    private fun getAddress(event: AddressEvent.GetAddress) =
        getData(
            getData = { addressRepository.getAddress(id = event.id) },
            getState = { state.value.getAddress },
            setState = { newState -> state.update { it.copy(getAddress = newState) } },
            onSuccess = { address ->
                state.value.address.value = address
            },
        )

    private fun addAddress() =
        getData(
            getData = { addressRepository.insert(state.value.address.value) },
            getState = { state.value.addEditAddress },
            setState = { newState -> state.update { it.copy(addEditAddress = newState) } },
            onSuccess = { address ->
                state.update {
                    it.copy(
                        getAddress = State.success(address),
                    )
                }
                state.value.address.value = address
            },
        )

    private fun editAddress() {

        if (!isAddressChanged()) {
            state.update {
                it.copy(
                    addEditAddress = State.success(state.value.address.value),
                )
            }

            return
        }

        getData(
            getData = { addressRepository.update(state.value.address.value) },
            getState = { state.value.addEditAddress },
            setState = { newState -> state.update { it.copy(addEditAddress = newState) } },
            onSuccess = { address ->
                state.update {
                    it.copy(
                        getAddress = State.success(address),
                    )
                }
                state.value.address.value = address
            },
        )
    }

    private fun updateAddressFields(event: AddressEvent.UpdateAddressFields) {
        state.value.address.value = event.address
    }

    private fun clear() =
        state.update {
            it.copy(
                getAddress = State(),
                addEditAddress = State(),
            )
        }.also {
            state.value.address.value = AddressModel.empty
        }

    private fun clearSuccessState() =
        state.update {
            it.copy(
                addEditAddress = State(),
            )
        }
}